import { Field, FieldRenderProps } from "react-final-form";
import "../Pricing.scss";
import "../i18n";
import { ConfigFormProps } from "./types";
import { useTranslation } from "react-i18next";
import { NumericInput } from "component/inputs/NumericInput";
import { useCallback } from "react";

const ConfigForm = ({ disableForm, testId }: ConfigFormProps): JSX.Element => {
  const { t } = useTranslation("polygonPricing");

  const renderPesosInput = useCallback(
    (props: FieldRenderProps<HTMLElement>, testId?: string) => {
      return (
        <div className="pesos-input-container">
          <p
            className={[
              "pesos-placeholder",
              props?.meta?.error && props?.meta?.touched && "error",
            ].join(" ")}
            data-testId={`${testId}-currency`}
          >
            {t("divisa")}
          </p>
          <NumericInput {...props} testId={testId} />
        </div>
      );
    },
    [t]
  );
  return (
    <>
      <h2 className="subTitle-pending">
        <p className="subtitle-pricing-h3" data-testId={`${testId}-title`}>
          {t("config")}
        </p>
      </h2>
      <div className="container-fluid pricing-container">
        <div className="container-pricing-col">
          <div className="container-row">
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="price.pickUp"
                label={t("colect")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxDecimal={2}
                maxInt={5}
                allowDecimal
                disabled={disableForm}
              >
                {(props) => renderPesosInput(props, `${testId}-pick-up`)}
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="price.delivered"
                label={t("finished")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxDecimal={2}
                maxInt={5}
                allowDecimal
                disabled={disableForm}
              >
                {(props) => renderPesosInput(props, `${testId}-delivered`)}
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="price.returned"
                label={t("devolution")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                disabled={disableForm}
                maxDecimal={2}
                maxInt={5}
                allowDecimal
              >
                {(props) => renderPesosInput(props, `${testId}-returned`)}
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="price.extraPickUpKm"
                label={t("colectBonus")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxDecimal={2}
                maxInt={5}
                allowDecimal
                disabled={disableForm}
              >
                {(props) => renderPesosInput(props, `${testId}-extra-pick-up`)}
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="price.extraDeliveredKm"
                label={t("finishedBonus")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxDecimal={2}
                maxInt={5}
                allowDecimal
                disabled={disableForm}
              >
                {(props) =>
                  renderPesosInput(props, `${testId}-extra-delivered`)
                }
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="price.extraReturnedKm"
                label={t("devolutionBonus")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxDecimal={2}
                maxInt={5}
                allowDecimal
                disabled={disableForm}
              >
                {(props) => renderPesosInput(props, `${testId}-extra-returned`)}
              </Field>
            </div>
            <div className="container-pricing-col-sm-5 container-pricing-col-xl-3">
              <Field
                name="price.rainBonus"
                label={t("rain")}
                className="Admin-Pickers-input"
                placeholder={"-"}
                maxDecimal={2}
                maxInt={5}
                allowDecimal
                disabled={disableForm}
              >
                {(props) => renderPesosInput(props, `${testId}-rain-bonus`)}
              </Field>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ConfigForm;
